import type { App } from 'vue';

// 导出水印组件
export { default as Watermark } from './Watermark';

// 导出报表配置组件
export { default as ReportConfig } from './ReportConfig';

export default {
  install(_Vue: App) {}
};
